import React from "react";
import { 
    // useDispatch, 
    useSelector } from 'react-redux';
import { Redirect } from "react-router-dom";


export default function Travelnotodetails() {
    const istravelno = useSelector(state => state.traveldetail.istravelno)
    // console.log(istravelno, "travelnumber")
    if (istravelno) {
        return (
            <Redirect to="/travelstep" />
        )
    } else {
        return (
            <Redirect to="/travelno" />
        )
    }
}
